import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SurveyModel } from 'src/app/core/_models/survey.model';
import { AppState } from 'src/app/core/_reducers';
import { SurveyRequestedAsnwer, SurveyRequestedCanceled, SurveyRequestedOmitted } from 'src/app/core/_reducers/_actions/survey.actions';
import { SurveysService } from 'src/app/core/_services/surveys.services';

@Component({
  selector: 'forrest-element-modal-surveys',
  templateUrl: './element-modal-surveys.component.html',
  styleUrls: ['./element-modal-surveys.component.scss']
})
export class ElementModalSurveysComponent {
  optionsQualifications: any = [
    {
      value: 1,
      label: '😡'
    }, {
      value: 2,
      label: '☹️'
    }, {
      value: 3,
      label: '😊'
    }, {
      value: 4,
      label: '😄'
    }, {
      value: 5,
      label: '😍'
    }]

  title: string = "¿Cómo calificas tu experiencia de compra?"

  constructor(
    private store: Store<AppState>,
    private _surveysServices: SurveysService,
    @Inject(MAT_DIALOG_DATA) public data: SurveyModel,
    public dialogRef: MatDialogRef<ElementModalSurveysComponent>,
  ) { }

  cancel() {
    this.store.dispatch(new SurveyRequestedCanceled({ survey_id: this.data.id }))
    this.dialogRef.close();
  }

  omitted(): void {
    this.store.dispatch(new SurveyRequestedOmitted({ survey_id: this.data.id }))
    this.dialogRef.close();
  }

  onSubmit(option: any) {
    let data = new SurveyModel(this.data)
    data.qualification = option.value
    this.store.dispatch(new SurveyRequestedAsnwer({ survey: data }))
    this.dialogRef.close();
  }
}
